import React from 'react';
import GlobalDialog from '../../../../mui/Dialogue/GlobalDialog';
import { Button, Box } from '@mui/material';
import { Icon } from '@iconify/react';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import StudentProfileLanding from '../../../../../views/crd/myworkspace/studentProfile/StudentProfileLanding';
import { getAdmRegStudentDetails } from '../../../../../redux/features/CRDslice';

export const Profile = React.memo(({ admNo }) => {
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  return (
    <div>
      <GlobalDialog
        title="Student Profile"
        fullWidth
        closeButton={true}
        open={open}
        setOpen={setOpen}
        maxWidth="lg"
        popupButton={
          <>
            <Button
              variant="outlined"
              size="small"
              onClick={() => {
                setOpen(true);
                dispatch(getAdmRegStudentDetails(admNo));
              }}
            >
              <Icon style={{ marginRight: '3px' }} icon="carbon:view" width="20" height="20" />
              View
            </Button>
          </>
        }
        content={
          <>
            <Box sx={{ height: 800 }}>
              {/*<StudentProfileData storeName={storeName} setOpen={setOpen} />*/}
              <StudentProfileLanding />
            </Box>
          </>
        }
      />
    </div>
  );
});
